import React from 'react';

import { ButtonBase, Fade, Paper, Popover } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import EmojiPicker, { Categories, EmojiStyle, Theme } from 'emoji-picker-react';
import { CategoriesConfig } from 'emoji-picker-react/dist/config/categoryConfig';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';

const emojiIcons = [
  '🙂',
  '🤣',
  '🥰',
  '🤩',
  '🤪',
  '🤑',
  '🤗',
  '🤭',
  '🤫',
  '🤔',
  '🤐',
  '🤨',
  '🙄',
  '😬',
  '🤥',
  '🤤',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',
  '🥴',
  '🤯',
  '🤠',
  '🥳',
  '🤓',
  '🧐',
  '🙁',
  '🥺',
  '🥱',
  '😤',
];

type EmojiButtonProps = {
  onSelect?: (emoji: string) => void;
};

const useStyles = makeStyles(theme => ({
  paper: {
    width: 350,
    background: 'none',
  },
  emojiButtonIcon: {
    transform: 'scale(1, 1)',
    filter: 'grayscale(100%)',
    fontSize: theme.typography.pxToRem(24),
    transition: theme.transitions.create(['transform', 'filter'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

export const categories: CategoriesConfig = [
  { category: Categories.SUGGESTED, name: 'Recentes' },
  { category: Categories.SMILEYS_PEOPLE, name: 'Smileys & pessoas' },
  { category: Categories.ANIMALS_NATURE, name: 'Animais & natureza' },
  { category: Categories.FOOD_DRINK, name: 'Comidas & bebidas' },
  { category: Categories.TRAVEL_PLACES, name: 'Viagens & lugares' },
  { category: Categories.ACTIVITIES, name: 'Atividades' },
  { category: Categories.OBJECTS, name: 'Objetos' },
  { category: Categories.SYMBOLS, name: 'Símbolos' },
  { category: Categories.FLAGS, name: 'Bandeiras' },
];

export default function EmojiButton({ onSelect }: EmojiButtonProps) {
  const classes = useStyles();
  const theme = useTheme();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'emoji-popper',
  });

  const [emojiIcon, setEmojiIcon] = React.useState(emojiIcons[0]);

  const handleSelectEmoji = (emoji: string) => {
    if (onSelect) onSelect(emoji);
  };

  const handleHoverEmojiButton = () => {
    const icon = emojiIcons[Math.floor(Math.random() * emojiIcons.length)];
    setEmojiIcon(icon);
  };

  return (
    <>
      <ButtonBase
        className={classes.emojiButtonIcon}
        onMouseEnter={handleHoverEmojiButton}
        disableRipple
        {...bindTrigger(popupState)}
      >
        {emojiIcon}
      </ButtonBase>

      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        TransitionComponent={Fade}
      >
        <Paper className={classes.paper}>
          <EmojiPicker
            categories={categories}
            autoFocusSearch
            previewConfig={{ showPreview: false }}
            onEmojiClick={emoji => handleSelectEmoji(emoji.emoji)}
            emojiStyle={EmojiStyle.NATIVE}
            theme={theme.palette.type === 'dark' ? Theme.DARK : Theme.LIGHT}
          />
        </Paper>
      </Popover>
    </>
  );
}
